<template>
    <div>
        <enter-header :page-name="hdText"></enter-header>
        <template v-if="getEnterDetail.data">
            <enter-list v-if="getEnterDetail.data.length > 0" :list="getEnterDetail.data" ></enter-list>
            <not-found-msg v-else></not-found-msg>
        </template>

        <!-- メニュー -->
        <enter-detail-menu ref="menu"></enter-detail-menu>

        <!-- 個人情報 -->
        <private-info ref="privateInfo"></private-info>

        <!-- 入場取消 -->
        <cancel-enter ref="cancelEnter" opt="1"></cancel-enter>

        <!-- メッセージ -->
        <info-msg ref="msg" :lev="lev" :msg="msg" @ok="msgOk"></info-msg>

        <!-- 契約期間 -->
        <contract-period ref="contract" opt="0"></contract-period>

    </div>
</template>

<script>
    import EnterHeader from 'pages/commons/header/Header'
    import EnterList from './components/List'
    import enterDetailMenu from './components/Menu'
    import NotFoundMsg from 'pages/commons/notFoundMsg/NotFoundMsg'
    import PrivateInfo from 'pages/commons/modal/privateInfo/PrivateInfo'
    import CancelEnter from 'pages/commons/modal/cancelIntvEnter/CancelIntvEnter'
    import InfoMsg from 'pages/commons/modal/infoMsg/InfoMsg'
    import ContractPeriod from 'pages/commons/modal/contractPeriod/ContractPeriod'

    import {mapGetters} from 'vuex'

    export default {
        components: {
            EnterHeader,
            EnterList,
            enterDetailMenu,
            NotFoundMsg,
            PrivateInfo,
            CancelEnter,
            InfoMsg,
            ContractPeriod
        },
        data () {
            return {
                lev: 0,
                msg: "",
                item: {},
                msgKey: ""
            }
        },
        mounted () {
            this.loadEnterDetail()
        },
        destroyed () {
            this.$store.dispatch('resetEnterDetail')
        },
        watch: {
            getEnterDetailLoadStatus (status) {
                if (status == '1') {
                    this.$store.dispatch('startProgress')
                }
                if (status == '2') {
                    this.$store.dispatch('doneProgress')
                }
                if (status == '3') {
                    this.$store.dispatch('doneProgress')
                }
            },
            getEnterConfirmStatus (status) {
                if (status == '1') {
                    this.$store.dispatch('startProgress')
                }
                if (status == '2') {
                    this.$store.dispatch('doneProgress')
                }
                if (status == '3') {
                    this.$store.dispatch('doneProgress')
                }
            }
        },
        computed: {
            hdText () {
                let day = this.$route.params.day
                return this.$moment(day).format('YYYY/MM/DD (dd)')
            },
            ...mapGetters(['getEnterDetail'
                        ,'getEnterDetailLoadStatus'
                        ,'getEnterConfirmStatus'
                        ])
        },
        methods: {
            loadEnterDetail () {
                this.$store.dispatch('loadEnterDetail', {
                    day: this.$route.params.day
                })
            },
            openPrivateInfo (userId) {
                this.$refs.privateInfo.openThis(userId)
            },
            cancelEnter (item) {
                this.$refs.cancelEnter.openThis(item)
            },
            openContractPeriod (item) {
                if (item.start_month == null) {
                    item.start_month = item.in_d.substr(0,7)
                }
                if (item.start_day == null) {
                    item.start_day = item.in_d.substr(8)
                }
                this.$refs.contract.openThis(item)
            },
            openMsg (lev, msg, key="", item) {
                this.lev = lev
                this.msg = msg
                this.msgKey = key
                this.item = item
                this.$refs.msg.openThis()
            },
            msgOk () {
                if (this.msgKey == 'enterConfirm') {
                    this.$store.dispatch('enterConfirm', {
                        inD: this.item.in_d,
                        intvId: this.item.id
                    })
                }
            },
        }
    }
</script>

<style lang="stylus" scoped>
</style>

